import React from 'react';
import Grid from '@mui/material/Grid2';
import FormLabel from '@mui/material/FormLabel';
import FormBlock from './FormBlock';
import { GridNumberField } from './shared';

function InlineNumberField({ label, name, allowedInputValue }) {
  return (
    <FormBlock variant="contained">
      <Grid size={{ xs: 6 }}>
        <FormLabel>{label}</FormLabel>
      </Grid>
      <GridNumberField
        xs={6}
        name={name}
        allowedInputValue={allowedInputValue}
      />
    </FormBlock>
  );
}

export default InlineNumberField;
